import {Button, LinkButton} from '@components/common/button/button'
import {observer} from 'mobx-react-lite'
import React from 'react'
import {Lang} from 'yougile-lang'
import {useProcessFile} from './use-process-file/use-process-file'
import {useImportFromFileStore} from './import-from-file-store'

export const ErrorPopupFooter = observer(() => {
  const [_, store] = useImportFromFileStore()
  const {processFile} = useProcessFile()

  const onClick = async () => {
    processFile(() => {
      store.setOpen(true)
    }, true)
  }

  return (
    <div className="flex flex-row justify-between px-24">
      <LinkButton onClick={() => store.setIsErrorPopupVisible(false)}>
        {Lang.msg.importFromFile.cancel}
      </LinkButton>
      <Button onClick={onClick} data-cy="import-popup__btn-proceed">
        {Lang.msg.importFromFile.proceed}
      </Button>
    </div>
  )
})
